module.exports = __webpack_public_path__ + "static/media/logo-facebook.5a07296e.png";